/**
 * Careers Block.
 * 
 */

/**
 * Desktop: 3-slide slick slider.
 * Mobile: Centered 1-slide slick slider.
 */

// Set up slick slider for job slides in mobile.




function initSlider() {
    // console.log('CAREERS: initSlider()');

	let 
	$mySlider = $('.careers-block__positions'),
	// $mySlider = $('.jobs'),
    mySliderSettings = {
        adaptiveHeight:false,
		arrows:true,
		prevArrow:"<div class='slick-arrow slick-prev'><img src='/wp-content/themes/remixtx/img/btn-arrow-next.svg'></div>",
		nextArrow:"<div class='slick-arrow slick-next'><img src='/wp-content/themes/remixtx//img/btn-arrow-next.svg'></div>",
		centerMode:true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
        swipeToSlide:true,
		variableWidth:true,
        responsive: [
			{
				breakpoint: 1023,
				settings: {
					centerMode:false,
					dots: false,
					infinite: true,
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			}, {
				breakpoint: 1349,
				settings: {
					prevArrow:"",
					centerMode:false,
					dots: false,
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}
        ]
    };

	$mySlider.slick(mySliderSettings);
}

exports.init = function () {
	// console.log('CAREERS: exports.init');
    // Run init methods...

	initSlider();
};